import { initials } from './initials'

const AVATAR_COLORS = ['#3b67ac', '#252f61', '#3a9e9b', '#ec6b31', '#429bdf', '#7a5cc4', '#c2577a'] as const

/** The colour a name gets when it has none of its own: stable for the same name. */
export function avatarColor(name: string): string {
  let sum = 0
  for (const ch of name) sum += ch.charCodeAt(0)
  return AVATAR_COLORS[sum % AVATAR_COLORS.length] ?? AVATAR_COLORS[0]
}

export interface AvatarProps {
  name: string
  /** For example a provider's colour. */
  color?: string
  size?: 'sm' | 'lg' | 'xl'
}

/** Initials in a coloured circle. Decorative: the name is always shown or announced next to it. */
export function Avatar({ name, color, size }: AvatarProps) {
  return (
    // The background is a real per-person value (Frontend §2.2 allows dynamic inline styles).
    <span className={`avatar ${size ?? ''}`} style={{ background: color ?? avatarColor(name) }} aria-hidden>
      {initials(name)}
    </span>
  )
}
